import React from 'react'
import css from './style.css'
import Modal from '../modal'
import { Grid, GridItem } from '../grid'
import Button from '../button'
import ChevronRightIcon from 'react-icons/lib/fa/chevron-right'
import ChevronLeftIcon from 'react-icons/lib/fa/chevron-left'
import PaginationButton from './pagination-button'
import DiamondDetails from '../diamond-details'
import DiamondPhoto from '../diamond-photo'
import ItemHeader from '../item-header'
import Price from '../price'

class DiamondModal extends Modal {
  shouldDisplayPreviousButton () {
    return this.props.diamondResultSetLength > 0 && this.props.diamondModalRowIndex > 0
  }

  shouldDisplayNextButton () {
    return this.props.diamondResultSetLength > 0 && this.props.diamondModalRowIndex < this.props.diamondResultSetLength - 1
  }

  render () {
    return (
      <Modal isOpen={this.props.isOpen} onRequestClose={this.props.onRequestClose}>
        <Grid>
          <GridItem col='1/10'>
            {this.shouldDisplayPreviousButton() && <PaginationButton onClick={this.props.onClickPrevious}><i><ChevronLeftIcon /></i></PaginationButton>}
          </GridItem>
          <GridItem col='8/10'>
            <Grid>
              <GridItem col='1/2'>
                <DiamondPhoto firstImageURL={this.props.modalRow['Image URL']} secondImageURL={this.props.modalRow['Image 2']} thirdImageURL={this.props.modalRow['Image 3']} />
              </GridItem>
              <GridItem col='1/2'>
                <ItemHeader type='diamond' data={this.props.modalRow} />
                <Price price={this.props.price} styleClass={css.price} />
              </GridItem>
            </Grid>
            <DiamondDetails data={this.props.modalRow} />
            <Button center disabled={!this.props.addable} onClick={this.props.addDiamondClicked}>Add Diamond</Button>
          </GridItem>
          <GridItem col='1/10'>
            {this.shouldDisplayNextButton() && <PaginationButton onClick={this.props.onClickNext}><i><ChevronRightIcon /></i></PaginationButton>}
          </GridItem>
        </Grid>
      </Modal>
    )
  }
}

export default DiamondModal



// WEBPACK FOOTER //
// ./src/components/diamond-modal/index.js